import { render, staticRenderFns } from "./MatterDecisionAdjustmentsForm.vue?vue&type=template&id=add783f8&"
import script from "./MatterDecisionAdjustmentsForm.vue?vue&type=script&lang=js&"
export * from "./MatterDecisionAdjustmentsForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterDecisionAdjustmentsForm.vue?vue&type=style&index=0&id=add783f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports